import style from "./style.module.scss";

export default function GroupRegisterProgress(props) {
  const { registered, expected } = props;

  let _hue = (registered / expected) * 90;
  _hue = _hue > 90 ? 90 : _hue;

  let _percent = (100 * registered) / expected;
  let _color = `hsl(${_hue} 100% 30%)`;
  if (_percent > 100) _percent = 100;

  return (
    <div className={style.container}>
      <span className={style.label}>
        {registered}/{expected} Formandos Ativos
      </span>
      <div
        className={style.progress_bar}
        style={{
          width: `${_percent}%`,
          backgroundColor: _color,
        }}
      ></div>
    </div>
  );
}
